import React from 'react';
import { AttachmentFileLink, AttachmentImageLink, AttachmentVideo } from '../ChatAttachment';

export default function MessageAttachments({ answer }) {
    const mediaAttachments = answer.Attachments?.filter(attachment => attachment.Type === 0 || attachment.Type === 1) || [];
    const fileAttachments = answer.Attachments?.filter(attachment => attachment.Type !== 0 && attachment.Type !== 1) || [];

    return (
        <>
            {!!mediaAttachments.length && (
                <div className="message__attachments">
                    {mediaAttachments.map((attachment, index) => (
                        <div className="message__attachment-item" key={`${answer.AnswerId}_media_${attachment.Url}_${index}`}>
                            {attachment.Type === 0
                                ? <AttachmentImageLink
                                    sourceUrl={attachment.Url}
                                    attachmentId={attachment.AttachmentId || attachment.Id}
                                    fileName={attachment.FileName}
                                    className="message__attachment-link"
                                    imageClassName="message__attachment-image"
                                    alt={attachment.FileName || `attachment-${index + 1}`}
                                  />
                                : <AttachmentVideo
                                    sourceUrl={attachment.Url}
                                    attachmentId={attachment.AttachmentId || attachment.Id}
                                    className="message__attachment-video"
                                  />}
                        </div>
                    ))}
                </div>
            )}
            {!!fileAttachments.length && (
                <div className="message__files">
                    {fileAttachments.map((attachment, index) => (
                        <AttachmentFileLink
                            key={`${answer.AnswerId}_file_${attachment.Url}_${index}`}
                            sourceUrl={attachment.Url}
                            attachmentId={attachment.AttachmentId || attachment.Id}
                            fileName={attachment.FileName}
                            className="message__file"
                        >
                            <span className="message__file-icon" />
                            <span className="message__file-name">{attachment.FileName || "Attachment"}</span>
                        </AttachmentFileLink>
                    ))}
                </div>
            )}
        </>
    );
}